// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3-WD3","infoBtn":"quickbooks_infoBtn__3w8Ia","formBox":"quickbooks_formBox__2_QNu","formFooter":"quickbooks_formFooter__hv3vS"};